import * as React from "react"


const HillLogoSvg = ({width, height, col}) => (
  <svg
 
    width={width}
    height={height}
    viewBox="0 0 392 125"
  >
    <path fill={col} d="M70 43.5V59h24v18H70v31h30V83h19v25h30V77h-24V59h24V28h-30v25h-19V28H70v15.5zm24 0V53H76V34h18v9.5zm49.8-.3-.3 9.3-9.2.3-9.3.3V34h19.1l-.3 9.2zM119 68v9h-19V59h19v9zM94 92.5v9.5H76V83h18v9.5zm50 0v9.5h-19V83h19v9.5zM171 68v40h20V75h28v33.1l10.3-.3 10.2-.3.3-39.8.2-39.7h-21v30h-28V28h-20v40zM256.4 28.9c-5.9 2.5-7.2 11-2.6 16.2 2.4 2.6 3.6 3.2 7.2 3.2 12.4 0 13.8-18.5 1.5-19.8-2.2-.3-5-.1-6.1.4zM282.2 67.7l.3 39.8 9.8.3 9.7.3V28h-20l.2 39.7zM314 68v40h19V28h-19v40zM251.2 80.7l.3 26.8h19l.3-26.8.2-26.7h-20l.2 26.7z" />
  </svg>
)
export default HillLogoSvg
